import { render, staticRenderFns } from "./BotaoSolicitarNovoDocumento.vue?vue&type=template&id=2ec60ba2&scoped=true"
import script from "./BotaoSolicitarNovoDocumento.vue?vue&type=script&lang=js"
export * from "./BotaoSolicitarNovoDocumento.vue?vue&type=script&lang=js"
import style0 from "./BotaoSolicitarNovoDocumento.vue?vue&type=style&index=0&id=2ec60ba2&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec60ba2",
  null
  
)

export default component.exports